import { format, parseISO } from '@sequencehq/utils/dates'
import { DATE_FORMAT_DISPLAY } from 'Invoices/constants'

// parseISO keeps the date-only value at local midnight; new Date() would
// parse it as UTC and shift the day in negative offsets.
export const formatAccountingDate = (date: string): string =>
  format(parseISO(date), DATE_FORMAT_DISPLAY)
